/**
 * CompleteStep.jsx
 * ================
 * Celebration screen at end of setup wizard
 */

import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import SetupWizard from './SetupWizard';

const CompleteStep = () => {
  const { appName } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const appType = searchParams.get('appType') || 'webapp';
  const [showConfetti, setShowConfetti] = useState(true);

  useEffect(() => {
    // Hide confetti after 3 seconds
    const timer = setTimeout(() => setShowConfetti(false), 3000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <SetupWizard currentStepKey="complete">
      <div style={{
        maxWidth: '800px',
        margin: '0 auto',
        padding: '40px 20px',
        textAlign: 'center',
        position: 'relative'
      }}>
        {/* Confetti effect */}
        {showConfetti && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            pointerEvents: 'none',
            zIndex: 1000
          }}>
            {[...Array(50)].map((_, i) => (
              <div
                key={i}
                style={{
                  position: 'absolute',
                  top: '-10px',
                  left: `${Math.random() * 100}%`,
                  width: '10px',
                  height: '10px',
                  backgroundColor: ['#10B981', '#3B82F6', '#EC4899', '#F59E0B', '#8B5CF6'][Math.floor(Math.random() * 5)],
                  animation: `fall ${2 + Math.random() * 3}s linear forwards`,
                  opacity: 0.8
                }}
              />
            ))}
          </div>
        )}

        <div style={{ fontSize: '80px', marginBottom: '24px' }}>
          🎉
        </div>

        <h2 style={{
          fontSize: '36px',
          fontWeight: '700',
          color: '#111827',
          marginBottom: '16px'
        }}>
          Congratulations!
        </h2>

        <h3 style={{
          fontSize: '24px',
          fontWeight: '600',
          color: '#6B7280',
          marginBottom: '40px'
        }}>
          Your {appType === 'static' ? 'static website' : 
                appType === 'webapp' ? 'web application' : 
                'enterprise application'} "{appName}" is ready!
        </h3>

        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          border: '1px solid #E5E7EB',
          padding: '32px',
          marginBottom: '32px'
        }}>
          <h4 style={{
            fontSize: '20px',
            fontWeight: '600',
            color: '#111827',
            marginBottom: '24px'
          }}>
            What's next?
          </h4>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <button
              onClick={() => window.open(`/app-preview?app=${encodeURIComponent(appName)}`, '_blank')}
              style={{
                padding: '16px 24px',
                fontSize: '16px',
                fontWeight: '600',
                color: 'white',
                backgroundColor: '#10B981',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px'
              }}
            >
              👁️ Preview Your App
            </button>

            <button
              onClick={() => navigate(`/page-builder?app=${appName}`)}
              style={{
                padding: '16px 24px',
                fontSize: '16px',
                fontWeight: '600',
                color: 'white',
                backgroundColor: '#3B82F6',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px'
              }}
            >
              🎨 Continue Editing
            </button>

            <button
              onClick={() => navigate('/dashboard')}
              style={{
                padding: '16px 24px',
                fontSize: '16px',
                fontWeight: '600',
                color: '#374151',
                backgroundColor: 'white',
                border: '2px solid #E5E7EB',
                borderRadius: '8px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                width: '100%'
              }}
            >
              📊 Go to Dashboard
            </button>
          </div>
        </div>

        <div style={{
          padding: '20px',
          backgroundColor: '#EFF6FF',
          borderRadius: '8px',
          border: '1px solid #DBEAFE'
        }}>
          <div style={{ fontSize: '14px', color: '#1E40AF', fontWeight: '600', marginBottom: '8px' }}>
            💡 Remember
          </div>
          <div style={{ fontSize: '14px', color: '#3B82F6' }}>
            You can always go back and refine any section from your dashboard.
            Your app is saved and ready to share!
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fall {
          to {
            transform: translateY(100vh) rotate(360deg);
            opacity: 0;
          }
        }
      `}</style>
    </SetupWizard>
  );
};

export default CompleteStep;













